import CheckedPrimary from '@/components/ui/icons/CheckedPrimary.vue'
import CheckedNew from '@/components/ui/icons/CheckedNew'
import LightBulb from '@/components/ui/icons/LightBulb.vue'
import ChartDown from '@/components/ui/icons/ChartDown'
import PaperAirplane from '@/components/ui/icons/PaperAirplane.vue'
import CoffeeMug from '@/components/ui/icons/CoffeeMug.vue'
import CheckmarkCircled from '@/components/ui/icons/CheckmarkCircled.vue'
import Lightning from '@/components/ui/icons/Lightning.vue'
import Plus from '@/components/ui/icons/Plus'
import Minus from '@/components/ui/icons/Minus'
import Discount from '@/components/ui/icons/Discount'
import ShoppingCart from '@/components/ui/icons/ShoppingCart'
import StepperDone from '@/components/ui/icons/stepper/StepperDone'
import StepperTodo from '@/components/ui/icons/stepper/StepperTodo'
import StepperActive from '@/components/ui/icons/stepper/StepperActive'
import StepperLoading from '@/components/ui/icons/stepper/StepperLoading'
import EventAvailable from '@/components/ui/icons/EventAvailable.vue'
import CalendarClock from '@/components/ui/icons/CalendarClock.vue'
import ChatRobot from '@/components/ui/icons/ChatRobot.vue'
import SoldToday from '@/components/ui/icons/SoldToday.vue'
import De from '@/components/ui/icons/flags/De'
import Gb from '@/components/ui/icons/flags/Gb'
import Nl from '@/components/ui/icons/flags/Nl'
import Se from '@/components/ui/icons/flags/Se'
import World from '@/components/ui/icons/flags/World'

export default {
  rtl: false,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      // dark: theme.dark,
      light: {
        textbase: '#101828',
        background: '#ffffff',
        surface: '#F1F1F1',
        primary: '#0096c7',
        secondary: '#2a4f66',
        accent: '#59bbbb',
        error: '#F44336',
        info: '#1849A9',
        success: '#12B76A',
        warning: '#ffd166',
        tertiary: '#5E17EB'
      }
    }
  },

  // icon libraries
  icons: {
    iconfont: 'mdiSvg',
    values: {
      lightning: {
        component: Lightning
      },

      plus: {
        component: Plus
      },
      minus: {
        component: Minus
      },
      shoppingCart: {
        component: ShoppingCart
      },
      discount: {
        component: Discount
      },
      checkedNew: {
        component: CheckedNew
      },
      lightBulb: {
        component: LightBulb
      },
      chartDown: {
        component: ChartDown
      },

      checkedPrimary: {
        component: CheckedPrimary
      },
      paperAirplane: {
        component: PaperAirplane
      },
      coffeeMug: {
        component: CoffeeMug
      },
      checkmarkCircled: {
        component: CheckmarkCircled
      },

      stepperDone: {
        component: StepperDone
      },
      stepperTodo: {
        component: StepperTodo
      },
      stepperActive: {
        component: StepperActive
      },
      stepperLoading: {
        component: StepperLoading
      },
      eventAvailable: {
        component: EventAvailable
      },
      calendarClock: {
        component: CalendarClock
      },
      chatRobot: {
        component: ChatRobot
      },

      soldToday: {
        component: SoldToday
      },
      de: {
        component: De
      },
      gb: {
        component: Gb
      },
      nl: {
        component: Nl
      },
      se: {
        component: Se
      },
      world: {
        component: World
      }
    }
  }
}
